import * as locales from 'date-fns/locale'
import { Locale } from 'date-fns'

type getLocaleType = () => Locale

const getLocale: getLocaleType = () => {
  // The following line has ts ignored because locales can only be indexed on
  // language codes 'enUS', 'enAU', 'ptBR', etc. and not on generic strings.
  // navigator.language returns language codes such as 'en-US'
  // @ts-ignore
  return locales[navigator.language.replace('-', '') || 'enUS']
}

export default getLocale
